import { render } from "./MonthlyMetrics.vue?vue&type=template&id=605f93fe&scoped=true"
import script from "./MonthlyMetrics.vue?vue&type=script&lang=js"
export * from "./MonthlyMetrics.vue?vue&type=script&lang=js"

import "./MonthlyMetrics.vue?vue&type=style&index=0&id=605f93fe&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605f93fe"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QField from 'quasar/src/components/field/QField.js';
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSeparator,QTr,QTd,QField,QDate});
